export default __webpack_public_path__ + "static/media/RDM_03.aeb05ebd.gif";